export const INSURANCE_INTRO_SETTING_KEY = 'insurance_vzr_intro_seen'
